// extracted by mini-css-extract-plugin
export var gradient = "section-module--gradient--Fod-o";
export var grey = "section-module--grey--z0qhy";
export var greyGradient = "section-module--greyGradient--siPSO";
export var none = "section-module--none--FhLfD";
export var sbShowMain = "section-module--sb-show-main--TBnrw";
export var section = "section-module--section--YiRvb";